export interface StackTodoTask {
  order: any;
  task: string;
  due?: string | Date;
}

export function todoDueTimestamp(due?: string | Date): number {
  if (!due) {
    return Number.POSITIVE_INFINITY;
  }
  const parsed = due instanceof Date ? due : new Date(due);
  if (isNaN(parsed.getTime())) {
    return Number.POSITIVE_INFINITY;
  }
  return parsed.getTime();
}

export function compareTodoTodayByDue(a: StackTodoTask, b: StackTodoTask): number {
  const dueDiff = todoDueTimestamp(a.due) - todoDueTimestamp(b.due);
  if (dueDiff !== 0) {
    return dueDiff;
  }
  return String(a.task || '').localeCompare(String(b.task || ''));
}

export function holdGeneratedInitials(order: any): string {
  const logs = Array.isArray(order?.log) ? order.log : [];
  for (let i = 0; i < logs.length; i++) {
    const item = String(logs[i]?.item || '').trim().toUpperCase();
    if (item === 'HOLD') {
      const initials = String(logs[i]?.initials || '').trim();
      if (initials) {
        return initials.toUpperCase();
      }
    }
  }
  const activity = order?.products?.[0]?.frame?.activity;
  if (Array.isArray(activity)) {
    for (let i = activity.length - 1; i >= 0; i--) {
      const status = String(activity[i]?.status || '').trim().toUpperCase();
      if (status === 'HOLD') {
        const by = String(activity[i]?.completedBy || '').trim();
        if (by) {
          return by.toUpperCase();
        }
      }
    }
  }
  return String(order?.initials || '').trim().toUpperCase();
}
